(function () {
  'use strict';

  /* Countdown timers — count to a real end date; hide once expired */
  function pad(n) { return String(n).padStart(2, '0'); }
  document.querySelectorAll('[data-countdown]').forEach(function (el) {
    var end = new Date(el.getAttribute('data-countdown')).getTime();
    if (isNaN(end)) { el.hidden = true; return; }
    var hh = el.querySelector('[data-hh]'), mm = el.querySelector('[data-mm]'), ss = el.querySelector('[data-ss]');
    function tick() {
      var diff = Math.max(0, end - Date.now());
      if (diff === 0 && el.hasAttribute('data-hide-expired')) { el.hidden = true; clearInterval(t); return; }
      var s = Math.floor(diff / 1000);
      hh.textContent = pad(Math.floor(s / 3600));
      mm.textContent = pad(Math.floor((s % 3600) / 60));
      ss.textContent = pad(s % 60);
    }
    var t = setInterval(tick, 1000); tick();
  });

  /* Ships-by date (skips weekends) */
  document.querySelectorAll('[data-ship-date]').forEach(function (el) {
    var days = parseInt(el.getAttribute('data-days'), 10) || 0;
    var d = new Date();
    while (days > 0) { d.setDate(d.getDate() + 1); if (d.getDay() !== 0 && d.getDay() !== 6) days--; }
    while (d.getDay() === 0 || d.getDay() === 6) d.setDate(d.getDate() + 1);
    el.textContent = d.toLocaleDateString('en-US', { weekday: 'short', day: 'numeric', month: 'short' }).replace(',', '');
  });

  /* Menu drawer */
  var drawer = document.getElementById('MenuDrawer');
  if (drawer) {
    document.querySelectorAll('[data-drawer-open]').forEach(function (b) {
      b.addEventListener('click', function () { drawer.hidden = false; document.body.style.overflow = 'hidden'; });
    });
    drawer.querySelectorAll('[data-drawer-close]').forEach(function (b) {
      b.addEventListener('click', function () { drawer.hidden = true; document.body.style.overflow = ''; });
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !drawer.hidden) { drawer.hidden = true; document.body.style.overflow = ''; } });
  }

  /* Product gallery thumbnails */
  document.querySelectorAll('[data-gallery]').forEach(function (g) {
    var slides = g.querySelectorAll('[data-slide]'), thumbs = g.querySelectorAll('[data-thumb]');
    thumbs.forEach(function (th) {
      th.addEventListener('click', function () {
        var i = th.getAttribute('data-thumb');
        slides.forEach(function (s) { s.classList.toggle('is-active', s.getAttribute('data-slide') === i); });
        thumbs.forEach(function (t) { t.classList.toggle('is-active', t === th); });
      });
    });
  });

  /* Expert carousel arrows */
  document.querySelectorAll('[data-carousel]').forEach(function (c) {
    var track = c.querySelector('[data-track]');
    function step() { var card = track.firstElementChild; return card ? card.getBoundingClientRect().width + 8 : 300; }
    var prev = c.querySelector('[data-prev]'), next = c.querySelector('[data-next]');
    if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: 'smooth' }); });
    if (next) next.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: 'smooth' }); });
  });

  /* Tabbed info box */
  document.querySelectorAll('[data-tabs]').forEach(function (box) {
    var btns = box.querySelectorAll('[data-tab]'), panels = box.querySelectorAll('[data-panel]');
    btns.forEach(function (b) {
      b.addEventListener('click', function () {
        var i = b.getAttribute('data-tab');
        btns.forEach(function (x) { x.classList.toggle('is-active', x === b); });
        panels.forEach(function (p) { p.classList.toggle('is-active', p.getAttribute('data-panel') === i); });
      });
    });
  });

  /* Smooth scroll for in-page CTA links */
  document.querySelectorAll('a[href="#buy"]').forEach(function (a) {
    a.addEventListener('click', function (e) {
      var t = document.getElementById('buy');
      if (t) { e.preventDefault(); t.scrollIntoView({ behavior: 'smooth', block: 'center' }); }
    });
  });

  /* Update button price when a variant is picked */
  document.querySelectorAll('.p-buy__select').forEach(function (sel) {
    sel.addEventListener('change', function () {
      var opt = sel.options[sel.selectedIndex], price = sel.closest('form').querySelector('[data-price]');
      if (price && opt) { var parts = opt.textContent.split('–'); if (parts[1]) price.textContent = parts[1].trim(); }
    });
  });
})();
